"use client";
import Loading from "@/components/common/Loading";
import { store } from "@/store/store";
import { CommonApiProvider } from "@/utils/firstTimeApiCall";
import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

export const persistor = persistStore(store);

export function ReduxProvider({ children }: { children: React.ReactNode }) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <Provider store={store}>
      {isClient ? (
        <PersistGate loading={<Loading />} persistor={persistor}>
          <CommonApiProvider>{children}</CommonApiProvider>
        </PersistGate>
      ) : (
        // On the server or with JS disabled, render the children directly.
        // This ensures the server-side component is visible.
        <CommonApiProvider>{children}</CommonApiProvider>
      )}
    </Provider>
  );
}
